<template>
    <div class="body-main">
        <section id="xnax">
            <!--    left Pane-->
            <left-bar></left-bar>
            <!--    left Pane END-->



            <!--    mid Pane-->
            <component :is="getInsideCurrentPage"></component>
            <!--    mid Pane END-->

            <!--    right Pane-->

            <right-bar></right-bar>
            <!--    right Pane-->
        </section>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    import LeftBar from '../components/sidebar/LeftBar'
    import RightBar from '../components/sidebar/RightBar'
    import Dashboard from '../components/Dashboard'

    import SendMoney from './sendMoney/SendMoney'
    import FundsTransfer from './sendMoney/FundsTransfer'
    import PhoneTransfer from './sendMoney/PhoneTransfer'
    import OwnTransfer from './sendMoney/OwnTransfer'
    import Confirmation from './utility/Confirmation'


    import PayBills from './payBills/PayBills'
    import Airtime from './payBills/Airtime'
    import MobileData from './payBills/MobileData'
    import OtherBills from './payBills/OtherBills'

    import AccountStatement from './accountStatement/AccountStatement'
    import RequestStatement from './accountStatement/RequestStatement'

    import AllAccount from './allAccount/AllAccount'

    import IndependentBanker from './independentBanker/IndependentBanker'

    import MoneyRequest from './moneyRequest/MoneyRequest'

    import FundMethod from './fundAccount/FundMethod'
    import CardFund from './fundAccount/FundByCard'
    import CashFund from './fundAccount/FundByCash'

    export default {
        name: "Inside",
        components: {
            leftBar: LeftBar,
            rightBar: RightBar,
            dashboard: Dashboard,

            sendMoney: SendMoney,
            fundsTransfer: FundsTransfer,
            phoneTransfer: PhoneTransfer,
            ownTransfer: OwnTransfer,
            confirmation: Confirmation,

            payBills: PayBills,
            airtime: Airtime,
            mobileData: MobileData,
            otherBills: OtherBills,

            accountStatement: AccountStatement,
            requestStatement: RequestStatement,

            allAccount: AllAccount,

            independentBanker: IndependentBanker,

            moneyRequest: MoneyRequest,

            fundMethod: FundMethod,
            cardFund: CardFund,
            cashFund: CashFund,
        },
        data () {
            return {
                alert: {
                    show: true,
                    type: 'success',
                    message: 'Invalid Credentials'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getUsername',
                'startAppLoading',
                'stopAppLoading',
                'getDataOnLogin',
                'getInsideCurrentPage',
            ])
        },
        created () {},
        methods: {
            ...mapActions([
                'updateCurrentComponent',
                'updateDataOnLogin',
                'updateAppLoading',
            ]),
        },
        mounted(){
            this.$nextTick(()=>{});
        },
    }
</script>

<style scoped>

</style>